module.exports = "<div class=\"checkbox inline\">\n\t<label>\n\t  <input type=\"checkbox\" class=\"ace\" (click)=\"onInputChange($event)\" />\n\t  <span class=\"lbl\">\n\t  \t<ng-content></ng-content>\n\t  </span>\n\t</label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/checkbox/checkbox.html
// module id = 527
// module chunks = 0